/**
 * Утилиты для работы со временем в московском часовом поясе (UTC+3)
 * Бэкенд отдает время в UTC, конвертируем для отображения
 */

/**
 * Парсит UTC время и возвращает Date объект
 * @param {string} isoString - ISO строка времени
 * @returns {Date} - Date объект
 */
export const parseUTCTime = (isoString) => {
  if (!isoString) return null;
  
  let utcString = isoString.trim();
  
  // Проверяем, указан ли часовой пояс (Z, +XX:XX, -XX:XX)
  const hasTimezone = utcString.endsWith('Z') || 
                       /[+-]\d{2}:\d{2}$/.test(utcString) ||
                       /[+-]\d{4}$/.test(utcString);
  
  if (!hasTimezone) {
    // Если часовой пояс не указан, считаем что это UTC и добавляем 'Z'
    if (utcString.includes('T')) {
      // Есть дата и время: "2026-01-06T06:20:00" -> "2026-01-06T06:20:00Z"
      utcString = utcString + 'Z';
    } else {
      // Только дата: "2026-01-06" -> "2026-01-06T00:00:00Z"
      utcString = utcString + 'T00:00:00Z';
    }
  }
  
  return new Date(utcString);
};

/**
 * Форматирует ISO строку времени в московское время (HH:MM)
 * @param {string} isoString - ISO строка времени (UTC)
 * @returns {string} - Время в формате HH:MM (московское время)
 */
export const formatMoscowTime = (isoString) => {
  if (!isoString) return '';
  const date = parseUTCTime(isoString);
  if (!date) return '';
  
  // Для отладки - раскомментируйте при необходимости
  // console.log('[timeUtils] Input:', isoString, '-> Output:', date.toISOString(), '-> Moscow:', 
  //   date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' }));
  
  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow'
  });
};

/**
 * Форматирует ISO строку времени в московское время с датой
 * @param {string} isoString - ISO строка времени (UTC)
 * @returns {string} - Дата и время в московском часовом поясе
 */
export const formatMoscowDateTime = (isoString) => {
  if (!isoString) return '';
  const date = parseUTCTime(isoString);
  if (!date) return '';
  
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow'
  });
};

/**
 * Получает текущее московское время
 * @returns {Date} - Текущее время
 */
export const getMoscowNow = () => {
  return new Date();
};

/**
 * Вычисляет разницу между двумя датами в секундах
 * @param {string|Date} futureTime - Будущее время
 * @param {Date} currentTime - Текущее время (по умолчанию - сейчас)
 * @returns {number} - Разница в секундах
 */
export const getTimeDifferenceInSeconds = (futureTime, currentTime = new Date()) => {
  const future = typeof futureTime === 'string' ? new Date(futureTime) : futureTime;
  const diffMs = future - currentTime;
  return Math.floor(diffMs / 1000);
};

